import useFetchAvailableRules from 'components/domain/property/rules/useFetchAvailableRules';
import useFetchPropertyRules from 'components/domain/property/rules/useFetchPropertyRules';
import { Channel } from 'models/Channels';
import { PropertyBusinessType } from 'models/Properties';
import usePropertySettingsInitData from 'pages/property/usePropertySettingsInitData';

const useRules = ({ activeChannels }: { activeChannels: Channel[] }) => {
  const { property } = usePropertySettingsInitData();
  const { uid, businessType } = property;
  const isHotel = businessType === PropertyBusinessType.HOTEL;
  const propertyUid = uid as string;

  const { data: propertyRules, isLoading: isLoadingPropertyRules } =
    useFetchPropertyRules({
      propertyUid,
    });
  const { data: availableRules, isLoading: isLoadingAvailableRules } =
    useFetchAvailableRules({ activeChannels, isHotel, propertyUid });

  return {
    availableRules: availableRules?.rules ?? [],
    propertyRules: propertyRules?.propertyRules ?? [],
    isLoadingRules: isLoadingAvailableRules || isLoadingPropertyRules,
  };
};

export default useRules;
